module.exports = __webpack_public_path__ + "img/webworthy-2.21f3194d.jpg";